var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25.846,
    viewBox: "0 0 24 25.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#0bb7a7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.064 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.537 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M147.537,4.885,142.921.27a.923.923,0,0,0-1.305,0L137,4.885a.923.923,0,0,0,1.305,1.305l3.04-3.04V8.307h1.846V3.151l3.04,3.04a.923.923,0,0,0,1.305-1.305Z",
    transform: "translate(-136.741 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.064 8.307)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.295,153.6H29.987V163.75a.923.923,0,0,1-1.846,0V153.6H19.833a2.769,2.769,0,0,0-2.769,2.769v12a2.769,2.769,0,0,0,2.769,2.769H38.295a2.769,2.769,0,0,0,2.769-2.769v-12A2.769,2.769,0,0,0,38.295,153.6Z",
    transform: "translate(-17.064 -153.596)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.5f831d21a191d4b5f599183494f1c6f8.svg";
export { ForwardRef as ReactComponent };